import { Link } from 'react-router-dom'

const FOOTER_LINKS = {
  Company: [
    { label: 'About', href: '/about' },
    { label: 'Careers', href: '/careers' },
    { label: 'Contact', href: '/contact' },
  ],
  Legal: [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Cookie Policy', href: '/cookies' },
  ],
  Community: [
    { label: 'Guidelines', href: '/guidelines' },
    { label: 'Help Center', href: '/help' },
    { label: 'Feedback', href: '/feedback' },
  ],
}

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer
      className="mt-12"
      style={{
        backgroundColor: 'var(--bg-secondary)',
        borderTop: '1px solid var(--rule)',
      }}
    >
      {/* Top accent rule — PlayoNetwork red */}
      <div className="h-0.5" style={{ backgroundColor: 'var(--accent)' }} />

      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {/* Brand block */}
          <div className="col-span-2 md:col-span-1">
            <div className="headline-serif text-2xl mb-3">PlayoNews</div>
            <p className="text-xs leading-relaxed max-w-xs" style={{ color: 'var(--text-tertiary)' }}>
              The front page of the PlayoNetwork. Real headlines, ranked,
              and connected — fewer steps from story to context.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(FOOTER_LINKS).map(([col, links]) => (
            <div key={col}>
              <div
                className="font-mono text-[10px] uppercase tracking-[0.18em] font-bold mb-3"
                style={{ color: 'var(--text-tertiary)' }}
              >
                {col}
              </div>
              <ul className="space-y-2">
                {links.map((l) => (
                  <li key={l.href}>
                    <Link
                      to={l.href}
                      className="text-sm hover-underline"
                      style={{ color: 'var(--text-secondary)' }}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom row */}
        <div
          className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-6"
          style={{ borderTop: '1px solid var(--rule)' }}
        >
          <p
            className="font-mono text-[10px] uppercase tracking-wider"
            style={{ color: 'var(--text-muted)' }}
          >
            © {year} PlayoNews · A PlayoNetwork Publication
          </p>
          <p
            className="font-mono text-[10px] uppercase tracking-wider"
            style={{ color: 'var(--text-muted)' }}
          >
            Made on the Playo Network
          </p>
        </div>
      </div>
    </footer>
  )
}
